import React from "react";
import "./Navbar.css";
import LanguageTranslation from "../components/languageTranslation";

const Navbar = () => {
  return (
    <header className="navbar">
      <div className="navbar-left">
        <img src="/logo.svg" alt="Logo" className="labubu" />
      </div>
      <div className="navbar-right">
        <LanguageTranslation />
      </div>
    </header>
  );
};

export default Navbar;
